class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8.491 4.088h-.977v4.889h.977v-4.89Zm-.489 6.355a.733.733 0 1 0 0 1.467.733.733 0 0 0 0-1.467Z"></path><path fill-rule="evenodd" d="M4.58 14.354h6.845a.489.489 0 0 0 .422-.242l3.422-5.867a.49.49 0 0 0 0-.492l-3.422-5.867a.49.49 0 0 0-.422-.243H4.58a.489.489 0 0 0-.422.243L.736 7.753a.489.489 0 0 0 0 .492l3.422 5.867a.488.488 0 0 0 .422.242Zm6.564-.977H4.861L1.724 7.999 4.861 2.62h6.283L14.281 8l-3.137 5.378Z" clip-rule="evenodd"></path></svg>';
  }
}
const e = "pi-warning-hex";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
